/**
 * @generated SignedSource<<a30610ae07006f3083b50f82078c60b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RetroPGFAddProjectToBallotModalContentFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RetroPGFModalApplicationRowFragment">;
  readonly " $fragmentType": "RetroPGFAddProjectToBallotModalContentFragment";
};
export type RetroPGFAddProjectToBallotModalContentFragment$key = {
  readonly " $data"?: RetroPGFAddProjectToBallotModalContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RetroPGFAddProjectToBallotModalContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RetroPGFAddProjectToBallotModalContentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RetroPGFModalApplicationRowFragment"
    }
  ],
  "type": "Project",
  "abstractKey": null
};

(node as any).hash = "e3f6392fb5129b3ec106c256b4a5b156";

export default node;
